import React, { useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
    const [state, handleSubmit] = useForm('mykdqwrb');

    // Close on Escape key
    useEffect(() => {
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        if (isOpen) window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="cm-overlay" onClick={onClose}>
            <div className="cm-dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
                <button className="cm-close" onClick={onClose} aria-label="Close">✕</button>

                {state.succeeded ? (
                    <div className="cm-success">
                        <div className="cm-success__icon">✓</div>
                        <h2 className="cm-success__title">You're on the list.</h2>
                        <p className="cm-success__msg">
                            An Iron Ridge Cyber representative will reach out to you shortly.
                        </p>
                        <button className="cm-submit" onClick={onClose}>Done</button>
                    </div>
                ) : (
                    <>
                        <div className="cm-header">
                            <div className="cm-label">Get Started</div>
                            <h2 className="cm-title">Generate Your First SBOM</h2>
                            <p className="cm-sub">
                                Leave your details and an Iron Ridge Cyber engineer will reach out to set up your evaluation.
                            </p>
                        </div>
                        <form className="cm-form" onSubmit={handleSubmit}>
                            <div className="cm-field">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    name="name"
                                    placeholder="Jane Smith"
                                    required
                                    autoFocus
                                    disabled={state.submitting}
                                />
                                <ValidationError prefix="Name" field="name" errors={state.errors} className="cm-error" />
                            </div>
                            <div className="cm-field">
                                <label htmlFor="email">Work Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    name="email"
                                    placeholder="jane@yourcompany.com"
                                    required
                                    disabled={state.submitting}
                                />
                                <ValidationError prefix="Email" field="email" errors={state.errors} className="cm-error" />
                            </div>
                            {state.errors && state.errors.length > 0 && !state.errors[0].field && (
                                <p className="cm-error">Something went wrong. Please try again.</p>
                            )}
                            <button type="submit" className="cm-submit" disabled={state.submitting}>
                                {state.submitting ? 'Sending…' : 'Request Access'}
                            </button>
                            <p className="cm-disclaimer">
                                No sales pressure. No auto-enrollment. We'll reach out once to schedule a brief onboarding call.
                            </p>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default ContactModal;
